import React, { useEffect } from "react";
import Prism from "prismjs";
import '../../../node_modules/prismjs/themes/prism-okaidia.css'
import '../../../node_modules/prismjs/plugins/toolbar/prism-toolbar.css'
import '../../../node_modules/prismjs/plugins/toolbar/prism-toolbar'
import '../../../node_modules/prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard'
import '../../../node_modules/prismjs/plugins/show-language/prism-show-language'
import '../../../node_modules/prismjs/components/prism-scss.min'
import '../../../node_modules/prismjs/components/prism-json.min'

const Snippet = props => {

    useEffect(() => {
        Prism.highlightAll();
    }, [props]);

    return (
        <div className="Code">
            <pre className={`language-${props.language}`}>
                <code>{props.code}</code>
            </pre>
        </div>
    );
}

export default Snippet

/* <Snippet code='npm install poke-css@1.0.0' language="html" /> */